import React from 'react';
import { Heart } from 'lucide-react';
import { Card } from './ui/card';

/**
 * The one card shape used by every grid in the app — Services, Learn,
 * Volunteer, Dialysis, Casket, Give, Popular Services and Saved. Keeping it in
 * a single place is what stops the grids drifting apart visually.
 *
 * `h-full` plus a column layout makes every card in a row the same height even
 * when titles wrap to different line counts.
 */
export default function OfferingCard({
  item,
  isSaved = false,
  onToggleSave,
  onClick,
  testId,
  saveTestId
}) {
  return (
    <Card
      data-testid={testId || `offering-card-${item.id}`}
      className="h-full flex flex-col overflow-hidden cursor-pointer card-hover"
      onClick={onClick}
    >
      <div className="relative h-20 md:h-32 flex-shrink-0 bg-muted">
        {item.image && (
          <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
        )}
        {item.tag && (
          <span
            className={`absolute top-1.5 left-1.5 px-1.5 py-0.5 rounded-md text-[9px] md:text-[10px] font-bold text-white ${item.tagColor || 'bg-primary'}`}
          >
            {item.tag}
          </span>
        )}
        {onToggleSave && (
          <button
            type="button"
            data-testid={saveTestId || `offering-save-${item.id}`}
            onClick={(e) => { e.stopPropagation(); onToggleSave(item.id); }}
            aria-label={isSaved ? 'Remove from saved' : 'Save'}
            className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-white/90 flex items-center justify-center"
          >
            <Heart className={`h-3 w-3 ${isSaved ? 'fill-rose-500 text-rose-500' : 'text-muted-foreground'}`} />
          </button>
        )}
      </div>
      <div className="p-2 md:p-3 flex-1 flex flex-col">
        <h3 className="text-[11px] md:text-sm font-bold leading-tight line-clamp-2">{item.title}</h3>
        {item.org && (
          <p className="text-[10px] md:text-xs text-muted-foreground mt-0.5 truncate">{item.org}</p>
        )}
        {item.date && (
          <p className="text-[10px] md:text-xs text-muted-foreground truncate">{item.date}</p>
        )}
      </div>
    </Card>
  );
}
